module.exports = __webpack_public_path__ + "static/media/success.398e1c40.svg";